export const types = {
    login:  '[auth] login',
    logout: '[auth] logout',
    change: '[auth] change',
    add: '[cart] add',
    remove: '[cart] remove',
    update: '[cart] update'
}